export default __webpack_public_path__ + "static/media/play.21818a93.svg";